import { NzUploadFile } from 'ng-zorro-antd/upload';

export const getBase64 = (file: NzUploadFile | File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file as File);
    reader.onload = (): void => resolve(reader.result as string);
    reader.onerror = (error): void => reject(error);
  });
